import { render, staticRenderFns } from "./CompanyRestoreDialog.vue?vue&type=template&id=1f8c2e70&scoped=true"
import script from "./CompanyRestoreDialog.vue?vue&type=script&lang=js"
export * from "./CompanyRestoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c2e70",
  null
  
)

export default component.exports